/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import _ from 'lodash';
import { Popover } from 'react-bootstrap';
import { UniqueOverlayTrigger } from 'edrolo/domains/overlays';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';
import PopoverContent from './PopoverContent';
import style from './ExamGridResultSquare.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const ExamGridResultSquare = ({
  response = {},
  question,
  sittingId,
  student,
  onChangedResponse,
  analyticsPayload,
  sittingLoaded,
}) => {
  let responseMarks = response.marks_final;
  const responseMarked = !isNaN(parseInt(responseMarks));
  responseMarks = responseMarked ? Number(responseMarks) : null;

  let teacherMarks = response.text_marks_from_teacher;
  const teacherMarked = !isNaN(parseInt(teacherMarks));
  teacherMarks = teacherMarked ? Number(teacherMarks) : null;

  const questionMarks = Number(question.marks);

  const getButtonText = () => {
    if (
      question.question_type === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
    ) {
      return response.your_answer || '–';
    }
    return responseMarks == null ? '–' : responseMarks;
  };
  const buttonText = getButtonText();

  const correct = responseMarks >= questionMarks;
  const incorrect = responseMarked && responseMarks < questionMarks;

  const grokkedOverride =
    incorrect && response.grokked === QUESTION_GROKKED.YES;
  const notGrokkedOverride =
    correct && response.grokked === QUESTION_GROKKED.NO;

  const buttonClass = cx({
    [style.indicator]: true,
    // TODO: we need to get rid of this grokkedOverride.
    // Green should either be correct, or understood. It should not toggle its meaning.
    [style.correct]: (correct && !notGrokkedOverride) || grokkedOverride, // green
    [style.incorrect]: (incorrect && !grokkedOverride) || notGrokkedOverride, // red
    [style.hasTeacherProvidedFeedback]:
      teacherMarked || !!response.comment_from_teacher, // circle
    [style.originallyCorrect]: notGrokkedOverride, // green corner
    [style.originallyIncorrect]: grokkedOverride, // red corner
  });

  const renderPopoverContent = (overlayControl) => (
    <Popover id={_.uniqueId()}>
      <PopoverContent
        sittingId={sittingId}
        student={student}
        question={question}
        response={response}
        questionMarks={questionMarks}
        responseMarks={responseMarks}
        onChangedResponse={(data) => {
          onChangedResponse(data);
          overlayControl.hide();
        }}
        onCancel={() => {
          overlayControl.hide();
        }}
        analyticsPayload={analyticsPayload}
      />
    </Popover>
  );

  return (
    <div className="indicator-container">
      {!sittingLoaded && <LoadingIndicator loadingText="Loading Results" />}
      {!!sittingLoaded && !sittingId && (
        <button className={`button-legacy ${buttonClass}`}>{buttonText}</button>
      )}
      {!!sittingLoaded && !!sittingId && (
        <UniqueOverlayTrigger
          trigger="click"
          placement="top"
          rootClose
          uniqueOverlayId={`exam-grid-indicator-${sittingId}-${question.id}`}
          renderOverlay={renderPopoverContent}
        >
          <button className={`button-legacy ${buttonClass}`}>
            {buttonText}
          </button>
        </UniqueOverlayTrigger>
      )}
      <UniqueOverlayTrigger
        trigger="click"
        placement="top"
        rootClose
        uniqueOverlayId={`exam-grid-note-${sittingId}-${question.id}`}
        renderOverlay={() => (
          <Popover id={_.uniqueId()}>{response.note}</Popover>
        )}
      >
        <button
          className={`button-legacy note-circle ${cx({
            active: response.note,
          })}`}
        >
          note
        </button>
      </UniqueOverlayTrigger>
    </div>
  );
};

export default ExamGridResultSquare;
